import React from "react";
import PrivateEventPage from "./PrivateEventPage";

const HERO = "https://customer-assets.emergentagent.com/job_spirituel-wellness/artifacts/fq3nq1jr_EVJF%20-%20Grande.jpeg";

// Questions spécifiques EVJF en haut de FAQ (avant les communes)
const FAQ_EXTRA = [
  {
    q: "Pourquoi choisir la voyance pour un EVJF ?",
    a: "Parce que ça change radicalement des prestations classiques (cours de pole dance, cocktails…). Une soirée voyance crée des souvenirs forts, intimes et joyeux. Les copines repartent avec leur tirage personnel et de vrais éclats de rire — l'effet wow est garanti, surtout si on combine avec un rituel de Pleine Lune pour bénir la future mariée.",
  },
  {
    q: "Ça fonctionne aussi pour un EVJG ou un EVG mixte ?",
    a: "Absolument ! La voyance n'a pas de genre : j'anime aussi bien des EVJG que des soirées mixtes. Le ton s'adapte à l'ambiance — plus complice avec un groupe de copines, plus narquois et joueur en mixte ou entre potes.",
  },
];

export default function EvjfPage() {
  return (
    <PrivateEventPage
      slug="evjf"
      h1="EVJF Voyance & Tarot — animation originale pour ta meilleure amie"
      heroEyebrow="EVJF / EVJG / EVG"
      heroSubtitle="Marque le coup avec une soirée voyance bienveillante et joyeuse pour la future mariée et ses copines. Mini-tirages personnalisés, rituels de Lune et messages lumineux — l'animation qui change vraiment des cours de pole dance. 🌕✨"
      metaTitle="EVJF Voyance & Tarot — Animation originale pour enterrement de vie de jeune fille"
      metaDescription="Animation EVJF voyance et tarot pour un enterrement de vie de jeune fille inoubliable. Mini-tirages, rituel de Pleine Lune et messages bienveillants. À partir de 70€/h, déplacement dans un rayon de 50 km autour de Montélimar (Drôme, Ardèche, Vaucluse)."
      keywords="EVJF voyance, EVJF tarot, animation EVJF originale, EVJG voyance, enterrement vie jeune fille voyance, idée EVJF, animation enterrement vie jeune fille, voyance copines, EVJF Drôme, EVJF Montélimar, EVJF Valence, EVJF Ardèche"
      heroImage={HERO}
      serviceName="Animation EVJF Voyance & Tarot"
      serviceDescription="Animation voyance et tirages de tarot pour enterrement de vie de jeune fille (EVJF/EVJG). Mini-tirages personnalisés, Cercle de Lune, guidance collective. Jusqu'à 10 participants, 2 à 3 heures, à partir de 70€/heure. Déplacement dans un rayon de 50 km autour de Montélimar (Drôme, Ardèche, Vaucluse)."
      faqExtra={FAQ_EXTRA}
      ctaSubject="Devis EVJF Voyance — Bilan 2 Vie"
    />
  );
}
